export const chatHelper = {
  chatStyle,
};

export const chatStyle = (template) => {
  if (template) {
    const obj = template.interaction.chat;
    if (obj) {
      const primaryColor = obj.primaryColor;
      const secondaryColor = obj.secondaryColor;
      const badgePillColor = obj.badgePillColor;
      const sendButtonColor = obj.sendButtonColor;
      const container = obj.container;
      const content = obj.content;
      const messagesStyle = obj.messages;
      const header = obj.header;
      const footer = obj.footer;

      return {
        primaryColor: primaryColor != "unset" ? primaryColor : "#5a60e3",
        badgePillColor: badgePillColor != "unset" ? badgePillColor : "#f50057",
        secondaryColor: secondaryColor != "unset" ? secondaryColor : "#fff",
        sendButtonColor: sendButtonColor != "unset" ? sendButtonColor : "inital",
        container: {
          borderWidth: container.borderWidth != "unset" ? container.borderWidth : "1px",
          borderColor: container.borderColor != "unset" ? container.borderColor : template.content.borderColor,
          borderRadius: container.borderRadius != "unset" ? container.borderRadius : template.content.borderRadius,
          borderStyle: "solid",
        },
        header: {
          background: header.background != "unset" ? header.background : "#fff",
          borderColor: header.borderColor != "unset" ? header.borderColor : "gainsboro",
          fontWeight: header.fontWeight != "unset" ? header.fontWeight : "initial",
          fontFamily: header.fontFamily != "unset" ? header.fontFamily : "Open Sans",
          color: header.color != "unset" ? header.color : "#222",
          fontSize: header.fontSize != "unset" ? header.fontSize : "1.8vh",
        },
        footer: {
          background: footer.background != "unset" ? footer.background : "#fff",
          borderColor: footer.borderColor != "unset" ? footer.borderColor : "gainsboro",
          inputColor: footer.inputColor != "unset" ? footer.inputColor : "initial",
          inputBackground: footer.inputBackground != "unset" ? footer.inputBackground : "#fff",
          fontFamily: footer.fontFamily != "unset" ? footer.fontFamily : "Open Sans",
        },
        content: {
          background: content.background != "unset" ? content.background : "#fff",
        },
        messages: {
          fontSize: messagesStyle.fontSize != "unset" ? messagesStyle.fontSize : "15px",
          lineHeight: messagesStyle.lineHeight != "unset" ? messagesStyle.lineHeight : "auto",
          fontWeight: messagesStyle.fontWeight != "unset" ? messagesStyle.fontWeight : "normal",
          fontFamily: messagesStyle.fontFamily != "unset" ? messagesStyle.fontFamily : "Open Sans",
          color: messagesStyle.color != "unset" ? messagesStyle.color : "#222",
          titleSize: messagesStyle.titleSize != "unset" ? messagesStyle.titleSize : "15px",
          adminBackgroundColor: messagesStyle.adminBackgroundColor != "unset" ? messagesStyle.adminBackgroundColor : "inital",
          adminTextColor: messagesStyle.adminTextColor != "unset" ? messagesStyle.adminTextColor : "inital",
          receiver: {
            backgroundColor: messagesStyle.receiver.backgroundColor != "unset" ? messagesStyle.receiver.backgroundColor : "inital",
            color: messagesStyle.receiver.color != "unset" ? messagesStyle.receiver.color : "inital",
          },
          sender: {
            backgroundColor: messagesStyle.sender.backgroundColor != "unset" ? messagesStyle.sender.backgroundColor : "inital",
            color: messagesStyle.sender.color != "unset" ? messagesStyle.sender.color : "inital",
          },
        },
      };
    }
  } else {
    return {
      primaryColor: "#5a60e3",
      badgePillColor: "#f50057",
      secondaryColor: "#fff",
      sendButtonColor: "inital",
      container: {
        borderWidth: "1px",
        borderColor: "transparent",
        borderRadius: 0,
      },
      header: {
        background: "#fff",
        borderColor: "gainsboro",
        fontWeight: "bold",
        fontFamily: "Open Sans",
        color: "#222",
        fontSize: "1rem",
      },
      footer: {
        background: "#fff",
        borderColor: "gainsboro",
        inputColor: "initial",
        inputBackground: "initial",
        fontFamily: "Open Sans",
      },
      content: {
        background: "#fff",
      },
      messages: {
        fontSize: "15px",
        fontWeight: "initial",
        lineHeight: "auto",
        fontFamily: "Open Sans",
        color: "#222",
        receiver: {
          backgroundColor: "#e4e6eb",
          color: "#050505",
        },
        sender: {
          backgroundColor: "#5a60e3",
          color: "#fff",
        },
      },
    };
  }
};

export const backstageChatStyle = {
  primaryColor: "rgb(22 88 197)",
  badgePillColor: "rgb(22 88 197)",
  secondaryColor: "#fff",
  sendButtonColor: "rgb(22 88 197)",
  container: {
    borderWidth: "1px",
    borderColor: "transparent",
    borderRadius: 0,
  },
  header: {
    background: "#fff",
    borderColor: "gainsboro",
    fontWeight: "bold",
    fontFamily: "Open Sans",
    color: "#222",
    fontSize: "1rem",
  },
  footer: {
    background: "#333333",
    borderColor: "transparent",
    inputColor: "#eee",
    inputBackground: "#4b4b4b",
    fontFamily: "Open Sans",
  },
  content: {
    background: "#333333",
  },
  messages: {
    fontSize: "15px",
    fontWeight: "initial",
    lineHeight: "auto",
    fontFamily: "Open Sans",
    color: "#eee",
    receiver: {
      backgroundColor: "#4b4b4b",
      color: "#fff",
    },
    sender: {
      backgroundColor: "rgb(22 88 197)",
      color: "#fff",
    },
  },
};
